import { makeStyles, createStyles } from '@material-ui/core';

const NotFoundStylesheet = makeStyles(theme => createStyles({
  
}));

export default NotFoundStylesheet;